<div class="account-pages my-5 pt-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4 text-center">
            <i class="bx bx-buildings font-size-48 text-muted d-block mb-3"></i>
            <h4 class="mb-2">You're not in an organization yet</h4>
            <p class="text-muted">
              You're signed in as <strong>{{ email }}</strong>, but this account isn't part of any
              organization on Echo.
            </p>

            <div class="alert alert-light border text-start">
              <p class="mb-2"><strong>If your team already uses Echo</strong></p>
              <p class="text-muted font-size-13 mb-3">
                Ask an administrator to invite you from <strong>Organization &rarr; Users</strong>.
                You'll get an email with a link that adds you to their organization.
              </p>
              <p class="mb-2"><strong>If you're the first one here</strong></p>
              <p class="text-muted font-size-13 mb-0">
                You can set up a new organization instead.
              </p>
            </div>

            <div class="d-grid gap-2">
              <a routerLink="/auth/register" class="btn btn-primary">Set up an organization</a>
              <button class="btn btn-light" (click)="contactSupport()">Contact Echo support</button>
              <button class="btn btn-link text-muted" (click)="signOut()">Sign out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
